import InputCodePub from "@/components/inputs/input-codepub";

const Default = {
    'US;ETATS UNIS': '<select name="STATE" class="textemobile" id="STATE"><option value="" selected="selected">Choisissez un état</option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">Californie</option><option value="NC">Caroline du nord</option><option value="SC">Caroline du sud</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="ND">Dakota du nord</option><option value="SD">Dakota du sud</option><option value="DE">Delaware</option><option value="FL">Floride</option><option value="GA">Georgie</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiane</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NY">New York</option><option value="NM">Nouveau Mexique</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvanie</option><option value="RI">Rhode Island</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginie</option><option value="WV">Virginie Occidentale</option><option value="WA">Washington</option><option value="DC">Washington DC</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option></select>',
    'CA;CANADA': '<input name="STATE" type="text" class="textemobile" id="STATE" size="30" placeholder="État / Province / Région">',
    onShow: () => {},
    onHide: () => {}
}

/**
 * Cette classe permet de gérer le champ de sélection ou l'input permettant de saisie un état
 * lorsque le pays choisi est les États Unis ou le Canada
 */
class InputState {

    /**
     * Constructeur de la class
     * @param target    Element cible
     * @param options
     */
    constructor (target, options = {}) {
        this._target = target
        this._options = { ...Default, ...options}
        this._init()
    }

    /**
     * Initialisation du composant
     * @private
     */
    _init () {

        if(this._options.trigger.value === "US;ETATS UNIS" || this._options.trigger.value === "CA;CANADA") {
            this.show(this._options.trigger.value)
        }

        this._options.trigger.addEventListener('change', (e) => {
            if(e.target.value === "US;ETATS UNIS" || e.target.value === "CA;CANADA") {
                this.show(e.target.value)
            } else {
                this.hide()
            }
        })
    }

    /**
     * Affiche l'input ou le champ de sélection permettant de renseigner l'état
     */
    show (stateType) {
        this._target.innerHTML = this._options[stateType]
        this._target.style.display = 'block'
        this._options.onShow()
    }

    /**
     * Cache l'input ou le champ de sélection permettant de renseigner l'état
     */
    hide () {
        this._target.innerHTML = '';
        this._target.style.display = 'none'
        this._options.onHide()
    }
}

if(typeof window !== "undefined") {
    window.InputState = InputState
}

/**
 * Initialisation de l'input
 * Déclenché sur les champs de type select ayant l'attribut data-state-target
 * La valeur de l'attribut data-state-target doit être un élément du DOM pouvant accueil l'input le champ de sélection
 * pour choisir l'état
 */
export function initInputState () {
    document.querySelectorAll('select[data-state-target]').forEach(trigger => {{
        const target = document.querySelector(trigger.getAttribute('data-state-target'));
        new InputState(target, {
            trigger
        })
    }})
}

export default InputState
